<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

<div class="mb-5 background_color">
  <h6 class="manage-boder pt-2 font1  decoration"> <a class="decoration" to="/issuetracking/index"> {{language[1]['Home']}}  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/issuetracking/contractor">{{language[92]['Allocate Issue Tracking']}}</router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> {{issue.issue_no}}  </h6>


 


  <div class="container-fluid">
 
    <div class="card custom_bdr_rds shadow p-2" v-if="isLoading">
                  <div class="card-body custom_bdr_rds">

                <div class="d-flex justify-content-center" >
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

                  </div>
                </div>

                <div v-else class="mt-1">
                <div >


           
  <b-modal :id="infoModal2.id" 
   @shown="initContractorViewMap"
   size="xl" hide-footer
    class="top-modal"> 
   <div>
    <div id="contractor-view-map" class="issue-map-container"></div>
   </div>
  </b-modal>

  <b-modal :id="infoModal3.id" 
  
   size="sm" hide-footer
   > 
   <div>
    <img :src="uploadedFile1" alt="Uploaded Image 1" width="100%"/>
   </div>
  </b-modal>

  <b-modal :id="infoModal4.id" 
  
   size="sm" hide-footer
    > 
   <div>
    <img :src="uploadedFile2" alt="Uploaded Image 1"  width="100%"/>
   </div>
  </b-modal>

  <b-modal :id="infoModal5.id" 
  
   size="sm" hide-footer
    class="top-modal"> 
   <div>
      <img :src="uploadedFile3" alt="Uploaded Image 1" width="100%" />
   </div>
  </b-modal>


                  <b-modal :id="infoModal1.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      size="sm" hide-footer
     bottom>
    <template  #modal-title>
     
      <h5 >Allocate to Contractor {{language[37]['Allocate to Contractor']}} </h5>


    </template>
    
   <div>
    <table class="table table-sm table-borderless">
      <tbody>
        <tr>
        <td style="width: 10px;">  <b-icon @click="remove" v-show="this.count>0" class="ms-1 me-1 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon></td>
        <td>  <v-select  v-model="detail[0].contractor" :options="contracs"  label="name" ></v-select></td>
        <td  style="width: 10px;"><b-icon @click="add" class=" mt-1 ms-1"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
        </tr>

        <tr v-for="key in count" :key="key">
        <td style="width: 10px;">  <b-icon @click="remove" class="ms-1 me-1 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon></td>
        <td>  <v-select  v-model="detail[key].contractor"  :options="contracs"  label="name"></v-select></td>
        <td  style="width: 10px;"> <b-icon @click="add" class=" mt-1 ms-1"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
        </tr>
      </tbody>
      
    </table>
      
   

   </div>
   <div class="modal-footer">
      
   
      <button type="button" @click="allocateSubmit(issue.id)" class="btn btn-sm btn-outline-primary bdr-rad"> {{language[30]['Allocate']}} </button>
    </div>
  

  
  </b-modal>


                <div class="card custom_bdr_rds shadow p-2">
                <div  class="card-body custom_bdr_rds">


    <table style="font-size: small; " class="table table-hover  table-sm table-borderless   ">
       
          <tbody>

            <tr>
              <td class="width-custom2"><b>ID</b></td>
             <td>{{ issue.id}}</td>
             <td style="text-align: right;">   
                <button type="button" @click="viewMap(issue.id)"
                 class="btn btn-sm btn-outline-primary bdr-rad me-1">{{language[29]['View Map']}} </button> 
                  </td> 
            </tr>
            <tr>
              <td><b> {{language[14]['Ticket Number']}}</b></td>
             <td >{{issue.issue_no}}</td> 
             <td></td> 
            </tr>
            <tr>
              <td><b> {{language[15]['Citizen Name']}}</b></td>
             <td>{{ issue.first_name}} {{issue.surname  }}</td> 
             <td></td> 
            </tr>
           
            <tr>
              <td><b> {{language[16]['Main Category']}}</b></td>
             <td>{{issue.relatedToMaincategory.category_name }}</td> 
             <td></td> 
            </tr>
            
          
            <tr>
              <td><b> {{language[17]['Sub Category']}} </b></td>
             <td>{{issue.relatedToSubcategory.category_name }}</td> 
             <td></td> 
            </tr>
            <tr>
              <td><b>{{language[18]['Citizen Mobile']}} </b></td>
             <td>{{issue.mobile }}</td> 
             <td></td> 
            </tr>
            <tr>
              <td><b>{{language[19]['Citizen Email']}}</b></td>
             <td>{{issue.email }}</td> 
             <td></td> 
            </tr>
            <tr>
              <td><b>{{language[20]['Address']}}  </b></td>
             <td>{{issue.address }}</td> 
             <td></td> 
            </tr>
            <tr>
              <td><b>{{language[21]['Description']}}  </b></td>
             <td>{{issue.description }}</td> 
             <td></td> 
            </tr>
            <tr v-if="uploadedFile1">
  <td><b>{{language[31]['Image']}} 1</b></td>
  <td>
    <a style="cursor:pointer"  @click="imageLoad1(uploadedFile1)" >
      <img :src="uploadedFile1" alt="Uploaded Image 1" style="max-width: 100px;" />
    </a>
  </td> 
  <td></td> 
</tr>

<tr v-if="uploadedFile2">
  <td><b>{{language[31]['Image']}} 2</b></td>
  <td>
    <a style="cursor:pointer"  @click="imageLoad2(uploadedFile2)" >
      <img :src="uploadedFile2" alt="Uploaded Image 2" style="max-width: 100px;" />
    </a>
  </td> 
  <td></td> 
</tr>

<tr v-if="uploadedFile3">
  <td><b> {{language[30]['Image']}} 3</b></td>
  <td>
    <a style="cursor:pointer"  @click="imageLoad3(uploadedFile3)" >
      <img :src="uploadedFile3" alt="Uploaded Image 3" style="max-width: 100px;" />
    </a>
  </td> 
  <td></td> 
</tr>
          
           
            <tr>
              <td><b>{{language[22]['Status']}} </b></td>
             <td v-show="this.lan=='English'">{{issue.relatedToStatus.status }}</td> 
             <td v-show="this.lan=='Swedish'">{{issue.relatedToStatus.status }}</td> 
             <td></td> 
            </tr>
            <tr>
              <td><b>{{language[23]['Created Date']}}</b></td>
             <td>{{ formatDate(issue.created_date) }}</td> 
             <td></td> 
            </tr>
            
           
             
          </tbody>


        </table>
       


        </div>
        </div>


        <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>{{language[33]['Allocated Contractor']}}</b></h6>

                        <div class="table-responsive">
                      
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2" >
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>{{language[34]['Name']}}</th>
                              <th>{{language[35]['mobile']}} </th>
                              <th>{{language[36]['email']}}</th>
                              <th>{{language[22]['status']}} </th>
                              <th>{{language[24]['Action']}} </th>
                            
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(contractor, index) in contractors" :key="contractor.id">
                              <td>{{index+1}}</td>
                              <td>{{contractor.name}}</td>
                              <td>{{contractor.mobile}}</td>
                              <td>{{contractor.email}}</td>
                              <td></td>
                              <td> <button  @click="jobView(contractor.alocate_id)"  class="btn btn-outline-primary btn-sm bdr-rad font-size_def">   {{language[28]['View']}}</button></td>
                            
                              </tr>
                            </tbody>

                          </table>
    
                        </div>

                        </div>
                    </div>



                    <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>{{language[38]['CRM Note']}} </b></h6>

                        <div class="table-responsive">
                      
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2" >
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>{{language[39]['Comment']}} </th>
                              <th>{{language[23]['Created Date']}} </th>
                         
                              <th>{{language[41]['Created By']}} </th>
                              <th>{{language[42]['Created Type']}} </th>
                           
                            
                              </tr>
                            </thead>
                            <tbody> 
                              <tr v-if="issue.description">
                                <td>1</td>
                                <td>{{ issue.description }}</td>
                                <td>{{ formatDate(issue.created_date) }}</td>
                                <td>{{ issue.first_name}} {{issue.surname  }}</td>
                                <td>Citizen</td>
                              </tr>
                              <tr  v-for="(crmnote, index) in crmnotes" :key="crmnote.id">
                              <td  v-if="issue.description">{{index+2}}</td>
                              <td  v-if="!issue.description">{{index+1}}</td>
                              <td>{{crmnote.comment}}</td>
                              <td>{{crmnote.created_date}}</td>
                              <td>{{crmnote.created_by}}</td>
                              <td>{{crmnote.type1}}</td>
                            
                            
                              </tr>
                            </tbody>

                          </table>
    
                        </div>


                        <br>

       
             

                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label">{{language[39]['Comment']}} </label>
                            <textarea rows="3" v-model="crm.comments"  class="form-control font-size_def" ></textarea>
                    </div>
                  </div>
             
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" >{{language[23]['Created Date']}} </label>
                            <input v-model="crm.followup_date" type="date"   class="form-control font-size_def" >
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label">{{language[74]['Follow up By']}} </label>
                            <input v-model="username"   class="form-control font-size_def" disabled>
                    </div>
                  </div>


                </div>
           
                <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
                <div class="d-flex  ">
                
                </div>
                <div class="d-flex  ">
                    <button @click="crmCreate()"  class="mr-1 btn btn-outline-primary btn-sm  mb-0 mt-0 font-size_def bdr-rad">{{language[43]['Add CRM Note']}}</button>
                </div>
                </div>





                        </div>
                    </div>


   
    

    




</div>
</div>
</div>
<br><br><br>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import httpClient from '@/axios';
 import vSelect from 'vue-select';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  const LEAFLET_CSS_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
  const LEAFLET_JS_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
  const LEAFLET_IMAGE_BASE_URL = 'https://unpkg.com/leaflet@1.9.4/dist/images/';

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        username:authService.isUsername(),
        language:JSON.parse(authService.isLanguage()),
       
        'idIssue':this.$route.query.id,
        
        issue:{},
        contractors:[],
        crmnotes:[],
        crm:{},
        lan:{},
        uploadedFile1: '',  
        uploadedFile2: '',  
        uploadedFile3: '',  
        isLoading:true,
        count: 0,
        map: null, // Controls the visibility of the modal
      latitude: null, // Store latitude
      longitude: null,
        contractorViewMap: null,
        infoModal1: {
          id: 'info-modal1',
          title: '',
          content: [],
        },
        infoModal2: {
          id: 'info-modal2',
          title: '',
          content: [],
        },
        infoModal3: {
          id: 'info-modal3',
          title: '',
          content: [],
        },
        infoModal4: {
          id: 'info-modal4',
          title: '',
          content: [],
        },
        infoModal5: {
          id: 'info-modal5',
          title: '',
          content: [],
        },

        contracs:[],
        detail:[
      {},  
      ],
        
      }

    },
    mounted(){
 
  this.loadCrm();
    },

    computed: {
    roundToTwoDecimal() {
      return detail => parseFloat(detail).toFixed(2);
    }
  },
methods : {

  
  formatDate(dateString) {
    const date = new Date(dateString); // Create a new Date object from the string

    // Manually format the date as DD-MM-YYYY with dashes
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    const formattedDate = `${day}-${month}-${year}`; // Combine date as DD-MM-YYYY
    
    // Format the time as HH:MM in 24-hour format
    const formattedTime = date.toLocaleTimeString('en-GB', {  
      hour: '2-digit', minute: '2-digit'
    });

    return `${formattedDate} ${formattedTime}`;  // Combine date and time
  },


   async imageLoad1(id){

    this.infoModal3.content = id;
    this.$root.$emit('bv::show::modal', this.infoModal3.id);
    
   },
   async imageLoad2(id){

    this.infoModal4.content = id;
    this.$root.$emit('bv::show::modal', this.infoModal4.id);
    
   },
   async imageLoad3(id){

    this.infoModal5.content = id;
    this.$root.$emit('bv::show::modal', this.infoModal5.id);
    
   },




  async viewMap(id){


try {
  const { data} = await  httpClient.get('/web/api/issuetracking/loadmap?id='+id,{
    headers:{
      'Authorization':'Bearer '+this.access_token,
      'Content-type': 'application/json',
     
    }
   });
   console.log(data);
   if(data.status==200){
          this.latitude = data.lan;
          this.longitude = data.lng;
          this.infoModal2.content = id;
          this.$root.$emit('bv::show::modal', this.infoModal2.id);
         
   }
  
} catch (error) {
  console.log(error.response);
}

},

  loadLeaflet() {
    if (window.L) {
      return Promise.resolve(window.L);
    }

    if (window.issueTrackingLeafletPromise) {
      return window.issueTrackingLeafletPromise;
    }

    window.issueTrackingLeafletPromise = new Promise((resolve, reject) => {
      if (!document.querySelector(`link[href="${LEAFLET_CSS_URL}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = LEAFLET_CSS_URL;
        document.head.appendChild(link);
      }

      const existingScript = document.querySelector(`script[src="${LEAFLET_JS_URL}"]`);
      const configureLeaflet = () => {
        if (!window.L) {
          reject(new Error('Leaflet did not initialize'));
          return;
        }

        delete window.L.Icon.Default.prototype._getIconUrl;
        window.L.Icon.Default.mergeOptions({
          iconRetinaUrl: `${LEAFLET_IMAGE_BASE_URL}marker-icon-2x.png`,
          iconUrl: `${LEAFLET_IMAGE_BASE_URL}marker-icon.png`,
          shadowUrl: `${LEAFLET_IMAGE_BASE_URL}marker-shadow.png`,
        });

        resolve(window.L);
      };

      if (existingScript) {
        existingScript.addEventListener('load', configureLeaflet, { once: true });
        existingScript.addEventListener('error', () => reject(new Error('Leaflet script failed to load')), { once: true });
        if (window.L) {
          configureLeaflet();
        }
        return;
      }

      const script = document.createElement('script');
      script.src = LEAFLET_JS_URL;
      script.defer = true;
      script.onload = configureLeaflet;
      script.onerror = () => reject(new Error('Leaflet script failed to load'));
      document.head.appendChild(script);
    });

    return window.issueTrackingLeafletPromise;
  },

  getMapMarkerIcon() {
    return window.L.divIcon({
      className: 'leaflet-red-marker-icon',
      html: '<span style="position:relative;display:block;width:26px;height:26px;background:#d93025;border:2px solid #fff;border-radius:50% 50% 50% 0;box-shadow:0 3px 8px rgba(0,0,0,.35);transform:rotate(-45deg);"><span style="position:absolute;top:7px;left:7px;width:8px;height:8px;background:#fff;border-radius:50%;"></span></span>',
      iconSize: [30, 42],
      iconAnchor: [15, 42],
      popupAnchor: [0, -38],
    });
  },

  async initContractorViewMap() {
    const lat = parseFloat(this.latitude);
    const lng = parseFloat(this.longitude);

    if (isNaN(lat) || isNaN(lng)) {
      return;
    }

    try {
      await this.loadLeaflet();
    } catch (error) {
      console.error('Leaflet failed to load', error);
      return;
    }

    const L = window.L;
    const mapDiv = document.getElementById('contractor-view-map');

    if (!mapDiv) {
      console.error('contractor-view-map div not found');
      return;
    }

    if (this.contractorViewMap) {
      this.contractorViewMap.remove();
      this.contractorViewMap = null;
    }

    mapDiv.innerHTML = '';
    if (mapDiv._leaflet_id) {
      mapDiv._leaflet_id = null;
    }

    this.contractorViewMap = L.map(mapDiv, {
      maxBounds: L.latLngBounds([55.005, 11.0274], [69.1062, 24.1553]),
      maxBoundsViscosity: 0.8,
    }).setView([lat, lng], 13);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
      maxZoom: 19,
    }).addTo(this.contractorViewMap);

    L.marker([lat, lng], {
      icon: this.getMapMarkerIcon(),
    }).addTo(this.contractorViewMap).bindPopup('Location of the issue').openPopup();

    setTimeout(() => this.contractorViewMap.invalidateSize(), 100);
  },

    closeMap() {
      
      this.latitude = null;
      this.longitude = null; // Reset coordinates when closing the map
    },
  


  async allocateSubmit(id){

this.$root.$emit('bv::hide::modal', this.infoModal1.id);
try {
  const { data} = await  httpClient.post('/web/api/issuetracking/allocatecreate?id='+id,{userid:this.userid,detail:this.detail},{
    headers:{
      'Authorization':'Bearer '+this.access_token,
      'Content-type': 'application/json',
     
    }
   });
   console.log(data);
   if(data.status==200){
    window.location.reload();
  
    
   
   }
  
} catch (error) {
  console.log(error.response);
  
}



},
      

  async Allocate(id){


try {
  const { data} = await  httpClient.get('/web/api/issuetracking/allocate?id='+id,{
    headers:{
      'Authorization':'Bearer '+this.access_token,
      'Content-type': 'application/json',
     
    }
   });
   console.log(data);
   if(data.status==200){
    this.contracs = data.contracs;
    this.infoModal1.content = id;
    this.$root.$emit('bv::show::modal', this.infoModal1.id);
   }
  
} catch (error) {
  console.log(error.response);
}



},


async crmCreate() {
   
   try {
     const { data} = await  httpClient.post('/web/api/issuetracking/usercrmcreate?id='+this.idIssue,
     {userid:this.userid,crm:this.crm},{
       headers:{
         'Authorization':'Bearer '+this.access_token,
         'Content-type': 'application/json',
        
       }
      });
      console.log(data);
      if(data.status==200){
        this.crm.comments = '';
        this.loadCrm();
      }
  
     
   } catch (error) {
     console.log(error.response);
   }
 },
  
  
  async loadCrm() {
   
    try {
      const { data} = await  httpClient.post('/web/api/issuetracking/contractorview?id='+this.idIssue,{userid:this.userid},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.issue = data.issues;
       this.contractors = data.contractors;
       this.uploadedFile1 = data.uploadedFile1;
       this.uploadedFile2 = data.uploadedFile2;
       this.uploadedFile3 = data.uploadedFile3;
       this.crmnotes = data.crmnotes;
       this.lan = data.lan;
       console.log(this.uploadedFiles);
       this.isLoading= false;
      
    } catch (error) {
      console.log(error.response);
    }
  },


  jobView(id){
    this.$router.push('/issuetracking/jobview?id='+id);
  },


  add: function(){
            this.count++;
            this.detail.push({
             
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              
            },1)
            
        },




},

    components :{
        ContentFooter,
        TopNavbar,
         'v-select': vSelect,
    },
  }

</script>
<style >
.issue-map-container {
  width: 100%;
  height: 420px;
}

.leaflet-red-marker-icon {
  background: transparent;
  border: 0;
}

</style>
